import React, { useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { withStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {
  TooltipState,
  ContentTooltip,
  ContentCalendar,
  StatusEvent,
} from "./CalendarComponent.styled";
import { useHistory } from "react-router-dom";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "white",
    margin: "9 0",
    color: themeConfig.neutral.gray[2500],
    border: "1px solid #dadde9",
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

const CalendarComponent = ({ heightCalendar, events }) => {
  const localizer = momentLocalizer(moment);
  const history = useHistory();

  const eventStyleGetter = (event, start, end, isSelected) => {
    const backgroundColor = event.hexColor;
    const style = {
      backgroundColor: backgroundColor,
      borderRadius: "6px",
      opacity: 0.8,
      border: "0px",
      display: "block",
      width: "auto",
      height: "auto",
    };
    return {
      style: style,
    };
  };

  const Event = ({ event }) => {
    const HoursStart = moment(event.start).format("hh:mm a").toString();
    const dateStart = moment(event.start, "YYYY-MM-DD").format("MMM Do");

    const HoursEnd = moment(event.end).format("hh:mm a").toString();
    const dateEnd = moment(event.end, "YYYY-MM-DD").format("MMM Do");

    return (
      <HtmlTooltip
        placement="top"
        //open
        title={
          <ContentTooltip>
            <TooltipState color={event.hexColor}></TooltipState>
            <div>
              <div
                style={{
                  fontSize: "14px",
                  margin: "0em 0px 1em",
                  fontWeight: "600",
                  display: "grid",
                  gridGap: "2px",
                }}
              >
                <div>
                  <div
                    style={{ color: event.hexColor, float: "left" }}
                  >{`${event.categoryName}:  `}</div>
                  <StatusEvent
                    status={event.status}
                  >{`(${event.status})`}</StatusEvent>
                </div>
                <div>
                  {event.title.length > 24
                    ? event.title.substr(0, 24) + "..."
                    : event.title}{" "}
                </div>
              </div>
              <div style={{ display: "inline-flex" }}>
                <span>{HoursStart}</span>
                <label>{dateStart}</label>
                <div style={{ margin: "0px 5px" }}>-</div>
                <span>{HoursEnd}</span>
                <label>{dateEnd}</label>
              </div>
            </div>
          </ContentTooltip>
        }
      >
        <div style={{ color: "white", height: "100%" }}>
          <strong>{event.title}</strong>
          {event.desc && ":  " + event.desc}
        </div>
      </HtmlTooltip>
    );
  };

  const redirectToDetail = (event) => {
    history.push({
      pathname: `/DetailEvent`,
      state: { idEvent: event.id, event: event, path: `/MyCalendar` },
    });
  };

  useEffect(() => {
    console.log("events", events)
  }, [events])

  return (
    <ContentCalendar height={heightCalendar}>
      <Calendar
        events={events}
        showMultiDayTimes
        startAccessor="start"
        endAccessor="end"
        defaultDate={new Date()}
        // date={selectedDay}
        // onNavigate={date => {
        //     setSelectedDay(date);
        //   }}
        eventPropGetter={eventStyleGetter}
        onSelectEvent={redirectToDetail}
        localizer={localizer}
        timeslots={2} //seccion de 30 min
        components={{
          event: Event,
        }}
        views={["month", "week", "day"]}
      />
    </ContentCalendar>
  );
};
export default CalendarComponent;
